<script setup>
const props = defineProps(["class"]);
</script>

<template>
	<svg
		:class="class"
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M15.3451 5.83317L11.1784 9.99984L15.3451 14.1665L14.1667 15.3449L10 11.1782L5.83335 15.3449L4.65497 14.1665L8.82164 9.99984L4.65497 5.83317L5.83335 4.65479L10 8.82145L14.1667 4.65479L15.3451 5.83317Z"
			fill="currentColor"
		/>
	</svg>
</template>
